import { useQuery } from "@tanstack/react-query";
import { limitAPI } from "../limitAPI.ts";

export const LIMIT_QUERY_KEY = "limit";

export const useGetLimitQuery = () => {
  return useQuery ({
    queryKey: [LIMIT_QUERY_KEY],
    queryFn: () => limitAPI.getLimit(),
    staleTime: 60 * 1000, // 1мин
    gcTime: 5 * 60 * 1000, // 5мин
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
    refetchOnMount: true,
  });
};
